export enum AppRoutes {
  Login = '/login',
  Register = '/register',
  PersonalInformation = '/personal-information',
  Documents = '/documents',
  Users = '/users',
  UserInformation = '/user-information/:id',
  UserDocuments = '/user-documents/:id',
  ForgotPassword = '/forgot-password',
  ChangePassword = '/change-password',
  FileApproval = '/file-approval',
  FileEdit = '/file-edit',
  Index = '/',
}

export enum Tags {
  ProfilePicture = 0,
  CompanyFile = 1,
  Authority = 2,
  Registration = 3,
  DotAudit = 4,
}

export type Tag = {
  name: string;
  company_id: number;
  created_dt: string;
  id: number;
  deleted: number;
  updated_dt: string;
}

export enum ApiStatus {
  Ok = 'ok',
}

export type PaginationProps = {
  items_no: number;
  current_page: number;
  items_per_page: number;
  total_pages: number;
};

export type UserTableProps = {
  users: User[];
  onDelete: (id: string | number) => void;
  rowsPerPage?: number;
  onPrevPage: () => void;
  onNextPage: () => void;
  currentPage: number;
  totalPages: number;
}


export type PaginatedAPIResponse<T> = PaginationProps & {
  items: T[];
};

export type UseAPIReturnType<T> = {
  deleteApi: (id?: string | number, params?: any) => Promise<void>;
  fildsAffected: string | undefined;
  data: any | PaginatedAPIResponse<T>;
  post: (data: any) => Promise<void>;
  get: (query?: string, context?: any) => Promise<any>;
  closeMessages: () => void;
  loading: boolean;
  successMessage: string | undefined;
  errors: string | undefined;
  put: (data: any) => Promise<void>;
  patch: (id?: string | number, data?: any) => Promise<void>;
};

export type User = {
  id: number;
  mail: string;
  phone: string;
  birthdate: string;
  type: number;
  name: string;
};

export enum UserType {
  Regular = 2,
  Admin = 3,
}